"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const zIndex_1 = __importDefault(require("../../../constants/zIndex"));
const style = {
    wrapper: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: zIndex_1.default.bottomMenu,
    },
    shadowArea: {
        width: '100%',
        backgroundColor: 'rgba(52, 52, 52, 0.5)',
    },
};
exports.default = style;
